export default __webpack_public_path__ + "static/media/Aircraft1-t.4f80c6ce.png";